import { Row } from '@shipt/design-system-layouts'
import { DealIcon } from '@shipt/design-system-icons'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicActivityPunchCardProgressDrawer } from '@/features/shop/components/Drawer/ActivityPunchCardProgressDrawer/DynamicActivityPunchCardProgressDrawer'
import { HeaderItem } from '@/features/shop/components/CategorySubNav/HeaderItem'
import { TransparentButton } from '@/features/shared/elements/Buttons'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { type ActivityPunchCardData } from '@/features/cms/components/CMS/types'
import styled from 'styled-components'

export const ActivityPunchCardNavigationItem = ({
  punchCardData,
  holidayGHP,
}: {
  punchCardData: ActivityPunchCardData
  holidayGHP?: boolean
}) => {
  const { openDialog } = useHandleDialog()

  const handleOnClick = () => {
    trackElementClicked({
      type: 'button',
      display_format: 'horizontal_list',
      content: `quest-id-${punchCardData.metadata.read_operation_info?.source_object.object.quest_id}`,
      display_sublocation: punchCardData.analytic_slug,
    })
    openDialog(DynamicActivityPunchCardProgressDrawer)
  }

  return (
    <TransparentButton onClick={handleOnClick}>
      <HeaderItem>
        <Row align="center" spacing="xs">
          <DealIcon size="md" concept="feedback" feedbackType="promotion" />
          <PunchCardCallout $holidayGHP={holidayGHP}>
            {punchCardData.data?.callout}
          </PunchCardCallout>
        </Row>
      </HeaderItem>
    </TransparentButton>
  )
}

const PunchCardCallout = styled.span<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP && theme.color.content.base.neutral.primary_inverse};
`
